import { AppLink } from '@/shared/components/AppLink';
import { cn } from '@/shared/utils/cn';
import { PDP_TRUST_BADGES } from '@/features/pdp/presentation/data/pdpTrustBadges.data';

function PdpTrustBadgeLabel({ badge }: { badge: (typeof PDP_TRUST_BADGES)[number] }) {
  if (badge.title) {
    return <span>{badge.title}</span>;
  }

  return badge.titleLines?.map((line) => (
    <span key={line} className="block">
      {line}
    </span>
  ));
}

interface PdpTrustBadgesProps {
  variant?: 'mobile' | 'desktop';
}

export function PdpTrustBadges({ variant = 'desktop' }: PdpTrustBadgesProps) {
  const isMobile = variant === 'mobile';

  return (
    <div
      className={cn(
        isMobile ? 'flex gap-2.5 md:hidden' : 'hidden border-y border-[#d9d9d9] md:flex'
      )}
    >
      {PDP_TRUST_BADGES.map((badge, index) => (
        <AppLink
          key={badge.id}
          to={badge.href}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            'flex min-h-0 flex-1 flex-col items-center justify-center gap-1 text-center text-xs leading-[15px] text-[var(--link-blue)] no-underline hover:underline',
            isMobile
              ? 'rounded-lg bg-white px-1.5 py-2.5 shadow-[0_1px_4px_rgba(0,0,0,0.06)]'
              : cn(
                  'px-2 py-2',
                  index > 0 && 'border-l border-[#d9d9d9]'
                )
          )}
        >
          <img
            src={badge.icon}
            alt=""
            aria-hidden
            className="h-4 w-4 shrink-0 object-contain opacity-80"
          />
          <PdpTrustBadgeLabel badge={badge} />
        </AppLink>
      ))}
    </div>
  );
}

/** @deprecated Use PdpTrustBadges with variant="desktop" */
export function PdpDesktopTrustBadges() {
  return <PdpTrustBadges variant="desktop" />;
}
